<ion-app [class.loggedin]="!!(user && user.uid)" [class.has-project]="!!project && !!project.uid">
  <ion-split-pane contentId="main-content">

    <ion-menu [hidden]="!menuData.visible" side="start" [class.subMode]="view.subMode" contentId="main-content"
      type="overlay">

      <ion-header class="ion-no-border">

        <ion-toolbar *ngIf="view.subMode || appConfig.showMenuHeaderLogo || appConfig.showMenuHeaderTitle">

          <img *ngIf="appConfig.showMenuHeaderLogo" src="./assets/img/icon.webp" (click)="onMenuHeaderLogoClick()"
            class="pipeline-logo icon light" />
          <img *ngIf="appConfig.showMenuHeaderLogo" src="./assets/img/icon-dark.webp" (click)="onMenuHeaderLogoClick()"
            class="pipeline-logo icon dark" />

          <img *ngIf="appConfig.showMenuHeaderLogo" src="./assets/img/logo.webp" (click)="onMenuHeaderLogoClick()"
            class="pipeline-logo light" />
          <img *ngIf="appConfig.showMenuHeaderLogo" src="./assets/img/logo-dark.webp" (click)="onMenuHeaderLogoClick()"
            class="pipeline-logo dark" />

          <ion-title *ngIf="appConfig.showMenuHeaderTitle" [innerHTML]="appConfig.appName"></ion-title>

        </ion-toolbar>

        <ion-toolbar *ngIf="!!appConfig.showMenuGlobalSearch">
          <ion-searchbar #globalSearchInput [placeholder]="'search_global_creator_studio'|translate"
            (ionInput)="runSearch($event)"></ion-searchbar>
        </ion-toolbar>

      </ion-header>

      <ion-content fullscreen="true">

        <!--  trigger="createPopoverHoverTrigger" triggerAction="hover" -->

        <ion-popover #createPopover [isOpen]="isCreatePopoverOpen" (didDismiss)="isCreatePopoverOpen = false">
          <ng-template>
            <ion-content>

              <ion-list *ngIf="!!view.globalCreateItems && !!view.globalCreateItems.length">

                <ion-item *ngFor="let item of view.globalCreateItems" (click)="selectGlobalCreateItem(item, $event)">
                  <ion-icon *ngIf="!!item.icon" [name]="item.icon" slot="start"></ion-icon>
                  <ion-label [innerHTML]="item.name|translate" class="ion-text-wrap"></ion-label>
                </ion-item>

              </ion-list>

            </ion-content>
          </ng-template>
        </ion-popover>

        <!-- global create element -->
        <ion-list lines="none" *ngIf="appConfig.showMenuAddButton">

          <ion-button lines="none" expand="block" fill="clear" detail="false" id="createPopoverHoverTrigger"
            (click)="showCreatePopover($event)" color="primary">
            <ion-icon slot="start" name="add-outline" color="primary"></ion-icon>
            <ion-label class="ion-text-wrap" color="primary">
              <h2 color="primary" [innerHTML]="'global_create_item'|translate"></h2>
              <p color="primary" [innerHTML]="'global_create_item_description'|translate"></p>
            </ion-label>
          </ion-button>

        </ion-list>

        <!-- global search results -->
        <ion-list lines="none" *ngIf="view.search_results && view.search_results.length">

          <ion-button lines="none" expand="block" fill="clear" detail="false"
            *ngFor="let p of view.search_results; let i = index" (click)="onMenuToggleClick(p)"
            [color]="!i ? 'primary' : 'dark'"
            [hidden]="(p.hideIfLoggedOut && !user.uid) || (p.hideIfLoggedIn && user.uid) || (p.allowedUserTypes && (!user || !user.classifications || (user.classifications && !user.classifications.type) || (user.classifications && user.classifications.type && p.allowedUserTypes.indexOf(user.classifications.type) === -1)))">
            <ion-icon slot="start" [name]="p.icon"
              [color]="view.currentMenuItem === p.key ? 'primary' : 'dark'"></ion-icon>
            <ion-label class="ion-text-wrap" [color]="view.currentMenuItem === p.key ? 'primary' : 'dark'">
              <h2 [innerHTML]="p.key|translate"></h2>
              <p [innerHTML]="(p.key + '_description')|translate"></p>
            </ion-label>
            <ion-badge *ngIf="p.badge != null" shape="round" [innerHTML]="p.badge" color="primary"></ion-badge>
          </ion-button>

        </ion-list>

        <!-- sidebar menu -->
        <ion-list lines="none" *ngIf="!view.search_results || !view.search_results.length">

          <!-- back button -->
          <ion-button *ngIf="view.subMode" lines="none" expand="block" fill="clear" detail="false" (click)="up()">
            <ion-icon slot="start" name="arrow-back-outline" color="primary"></ion-icon>
            <ion-label class="ion-text-wrap" color="primary">
              <h2 [innerHTML]="'back'|translate"></h2>
              <p [innerHTML]="view.parentMenuItem|translate"></p>
            </ion-label>
          </ion-button>

          <!-- sidebar menu items -->
          <div class="button-wrapper" *ngFor="let p of appPages; let i = index" [class.active]="p.active"
            [hidden]="(p.hideIfLoggedOut && !user.uid) || (p.hideIfLoggedIn && user.uid) || (p.allowedUserTypes && (!user || !user.classifications || (user.classifications && !user.classifications.type) || (user.classifications && user.classifications.type && p.allowedUserTypes.indexOf(user.classifications.type) === -1)))">

            <ion-button lines="none" expand="block" fill="clear" detail="false" (click)="onMenuToggleClick(p, i)"
              [class.has-children]="!!p.children">

              <ion-icon slot="start" [name]="p.icon"
                [color]="view.currentMenuItem === p.key ? 'primary' : 'dark'"></ion-icon>

              <ion-label class="ion-text-wrap" [color]="view.currentMenuItem === p.key ? 'primary' : 'dark'">
                <h2 [innerHTML]="p.key|translate"></h2>
                <p [innerHTML]="(p.key + '_description')|translate"></p>
              </ion-label>

              <ion-badge *ngIf="p.badge != null" shape="round" [innerHTML]="p.badge" color="primary"></ion-badge>

              <ion-icon class="chevron" *ngIf="!!p.children" color="dark"
                [name]="p.active ? 'chevron-up-outline' : 'chevron-down-outline'" slot="end"></ion-icon>

            </ion-button>

            <!-- button children -->
            <div class="button-children" *ngIf="!!p.children" [hidden]="!p.active">
              <ion-button *ngFor="let child of p.children" lines="none" expand="block" fill="clear" detail="false"
                (click)="onMenuToggleClick(child, i)">

                <ion-icon slot="start" [name]="child.icon"
                  [color]="view.currentMenuItem === child.key ? 'primary' : 'dark'"></ion-icon>

                <ion-label class="ion-text-wrap" [color]="view.currentMenuItem === child.key ? 'primary' : 'dark'">
                  <h2 [innerHTML]="child.key|translate"></h2>
                  <p [innerHTML]="(child.key + '_description')|translate"></p>
                </ion-label>

                <ion-badge *ngIf="child.badge != null" shape="round" [innerHTML]="child.badge"
                  color="primary"></ion-badge>

              </ion-button>
            </div>

          </div>

        </ion-list>

      </ion-content>

      <!-- footer -->
      <ion-footer class="ion-no-border" color="light">

        <ion-toolbar class="ion-no-border">

          <!-- class="step-{{view.step ? view.step.index || 0 : 0}}" -->
          <getgenius-dani [hidden]="!!view.dani.state.hidden" (click)="dani()"
            *ngIf="!!view.isDesktop && !!appConfig.showGetGeniusDaniInSidebar" [config]="view.dani.config"
            [state]="view.dani.state"></getgenius-dani>

          <ion-grid>
            <ion-row>

              <!-- user -->
              <ion-col [size]="appConfig.useHelpCenterExtension ? 4 : 6" *ngIf="user && !!user.uid">
                <ion-button fill="clear" expand="block" color="dark" (click)="onUserClicked()">
                  <ion-avatar>
                    <ion-img [src]="user.photo || fallbackAvatarImg" (ionError)="userPhotoLoadingFailed()"></ion-img>
                  </ion-avatar>
                  <ion-label [innerHTML]="user.firstname || user.nickname" class="ion-text-wrap"></ion-label>
                </ion-button>
              </ion-col>

              <!-- team -->
              <ion-col [size]="appConfig.useHelpCenterExtension ? 4 : 6" *ngIf="team && !!team.uid">
                <ion-button fill="clear" expand="block" color="dark" (click)="onTeamClicked()">
                  <ion-avatar>
                    <ion-img [src]="team.photo || fallbackImg" (ionError)="teamPhotoLoadingFailed()"></ion-img>
                  </ion-avatar>
                  <ion-label [innerHTML]="team.name" class="ion-text-wrap"></ion-label>
                </ion-button>
              </ion-col>

              <!-- help center -->
              <ion-col size="4" *ngIf="!!appConfig.useHelpCenterExtension">
                <ion-button fill="clear" expand="block" icon-only color="dark" id="footerSupportItem"
                  (click)="support()">
                  <ion-icon name="help-circle-outline" color="dark"></ion-icon>
                </ion-button>
              </ion-col>

            </ion-row>
          </ion-grid>

        </ion-toolbar>

        <ion-toolbar class="ion-no-border" color="light" *ngIf="!!appConfig.useShop && !!appConfig.showBasketInSidebar"
          [hidden]="!basketInfo || !basketInfo.items">
          <ion-list color="light">
            <ion-menu-toggle *ngIf="user && user.uid" auto-hide="false">
              <ion-item lines="none" (click)="basket()" color="light">
                <ion-label>
                  <h3 [innerHTML]="'basket'|translate"></h3>
                  <p>
                    <small
                      [innerHTML]="(basketInfo.items || ('no_2'|translate)) + ' ' + (basketInfo.items === 1 ? ('product'|translate) : ('products'|translate))"></small>
                  </p>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>
        </ion-toolbar>

      </ion-footer>

    </ion-menu>

    <ion-router-outlet id="main-content" swipeGesture="false"></ion-router-outlet>

  </ion-split-pane>
</ion-app>